import { renderFormItem } from '@/pages/documentCompile/dict/help';
import { DictData, DictTemplateCodeEnum } from '@/pages/documentCompile/dict/type';
import { getDictTableData } from '@/pages/documentCompile/dict/utils';
import useMethods from '@/pages/documentCompile/onlyofficeFieldSetting/hooks/usemethods';
import { Form, Input, Modal, Button } from 'antd'
import { useEffect, useState } from 'react';
import dayjs from 'dayjs'
import { DocSearchCodes } from '@/pages/documentCompile/project/constants';
import { isNotUndefined } from '@/utils/tools';


// 仅前端使用
export const AddProjectAntdFormViewId = 'zlgcmc'

interface Props {
    open: boolean;
    onCancel: () => void;
    onOk: (values: any) => void;
    onJump?: () => void;
    record?: any;
    dictData: DictData[];
    projectItemAttrs?: any;
    openDialogType?: string
}
export default function ProjectForm({ open, onCancel, onOk, onJump, record,openDialogType, dictData, projectItemAttrs }: Props) {
    const [form] = Form.useForm();
    const [projectNameFlag, setProjectNameFlag] = useState(false);
    const { filterSubmitSettingFieldValue, getAntdFormData } = useMethods();

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            let newValues = filterSubmitSettingFieldValue(values)
            onOk(newValues);
        } catch (error) {
            console.error('表单验证失败:', error);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    const initData = async () => {
    }

    useEffect(() => {
        if (!open) return;
        initData();
    }, [open]);

    useEffect(() => {
        if (!open) return;
        if (projectItemAttrs) {
            const formValues = {}
            projectItemAttrs.forEach(item => {
                formValues[item.name] = item.value;
            })
            const newFormValues = getAntdFormData(formValues)
            form.setFieldsValue(newFormValues);
            form.setFieldsValue({ zlgcmc: record?.projectName })
        } else {
            // 新建工程展示默认开工
            const dictItem = dictData.find(item => item.dictCode === DocSearchCodes.projectStatus)
            const defaultStatus = dictItem?.attr_nr?.find(attr => attr.label === '开工')?.value
            if (isNotUndefined(defaultStatus)) {
                form.setFieldsValue({ zlgcmc: record?.projectName, [DocSearchCodes.projectStatus]: defaultStatus });
            }
            setProjectNameFlag(true)

        }
        // 获取表单值
        // const values = form.getFieldsValue();
        // console.log("values", values);
    }, [open, projectItemAttrs]);


    const handleSkip = () => {
        // onJump();
        onOk({});
    };

    return (
        <Modal
            open={open}
            onCancel={handleCancel}
            onOk={handleOk}
            title="项目信息"
            width={800}
            destroyOnClose
            footer={[
                <Button key="cancel" onClick={handleCancel} style={{ marginRight: 12 }}>
                    取消
                </Button>,
                <Button key="ok" type="primary" onClick={handleOk} style={{ marginRight: 0 }}>
                    确定
                </Button>,
                openDialogType !== 'edit' && (
                    <Button key="skip" type="primary" ghost onClick={handleSkip}>
                        跳过
                    </Button>
                ),
            ]}
        >
            <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                {dictData.map((item) => (
                    <Form.Item
                        key={item.id}
                        name={item.dictCode}
                        label={item.dictName}
                        rules={[]}
                    >
                        {renderFormItem(item, false, item.dictCode === 'zlgcmc' && projectNameFlag)}
                    </Form.Item>
                ))}
            </Form>
        </Modal >
    )
}   
